import { render } from "./ActivityEDItem.vue?vue&type=template&id=10580606"
import script from "./ActivityEDItem.vue?vue&type=script&lang=js"
export * from "./ActivityEDItem.vue?vue&type=script&lang=js"
script.render = render

export default script